import { LinkUIBasic, LinkUIBlueBold, LinkUIBlueBoldUnderlined, LinkUIBold, LinkUIOrangeBoldUnderlined, LinkUIUncolored } from "./common_links";
import { BRR } from "./common_ui_components";

function LinkedInLink({ text, url }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="
        ml-1 inline-flex items-center rounded-full
        bg-blue-50 px-3 py-1
        font-semibold text-blue-700 underline underline-offset-4
        transition hover:bg-blue-100 hover:text-blue-800
      "
    >
      {text}
    </a>
  );
}

function MockInterviewLink({ text, url }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="
        inline-flex items-center justify-center rounded-full
        bg-orange-600 px-5 py-2.5
        text-sm font-bold text-white no-underline
        shadow-sm transition
        hover:bg-orange-700 hover:shadow-md
      "
    >
      {text}
    </a>
  );
}

/**
 *  connect with founder on linkedin and
 *  book meeting on topmate
 */
function ConnectAndBook(){
    return (
    <div className="flex flex-col w-full pt-4">
        <div className='flex flex-row-responsive 
items-center justify-center rounded-3xl bg-gradient-to-br from-orange-50 via-white to-blue-50 border border-orange-100 shadow-sm px-5 py-6 gap-6 '>

  {
  <div className="flex flex-col justify-center items-center px-4 text-center">
    <div className="rounded-2xl bg-white/90 px-6 py-5 text-gray-700 leading-8 shadow-sm border border-gray-100">
      For discussions and suggestions, 
      <br />
  Let's connect on  
  
  <LinkedInLink text="LinkedIn" 
    url = "https://www.linkedin.com/in/prashant-priyadarshi-2705334a/" />
    
    </div>
  <br />
      <MockInterviewLink
          url= "https://topmate.io/prashant_priyadarshi"
          text="Book LLD Mock Interview with me" /> 
  
 </div>
 }

{ false &&   
<div className='flex flex-col text-center
  p-8 m-8 leading-8 font-mono'>
    Book LLD Mock Interview With Me through, <br />
 <span> 
   <LinkUIBasic
url= "https://topmate.io/prashant_priyadarshi"
text="TopMate" />
or 
 <LinkUIBasic
      url= "https://www.meetapro.com/mock-interview/mock-interview-for-low-level-design-lld-round-1071105"
      text="MeetAPro (USA)" />  
  
</span> 

       {/* USD 20/- only
       */}
       <br />
<a 
href = "https://www.linkedin.com/in/prashant-priyadarshi-2705334a/"
 target="_blank" rel="noopener noreferrer" >

{
//For discussions and suggestions, <br />
}
Let's connect on 
&nbsp;
 <span className="text-teal-700 font-semibold underline">
  LinkedIn</span></a>


</div>
}

<div className="flex flex-col p-5 items-center rounded-3xl bg-white/90 shadow-sm border border-gray-100">
  <img className=' w-48 rounded-3xl bg-white object-cover shadow-md ring-4 ring-orange-100'   
          src="https://public-items-1.s3.ap-south-1.amazonaws.com/codezym/face/canva_face_low_quality_6_20kb.jpg"
      />
      
      <div className="text-gray-700 text-center
       text-sm font-mono mt-3 leading-6">
        Prashant Priyadarshi <br /> Founder, CodeZym
      </div>
</div>

</div>
</div>)  
};

export {ConnectAndBook}